const apiV1 = 'api/v1'
export const API_ENDPOINTS = {
	LOGIN: `${apiV1}/login`,
	LOGOUT: `${apiV1}/logout`,
	SIGNUP: `${apiV1}/user/register`,
	FETCH_PINCODE: `${apiV1}/state/district/{pincode}`,
	FETCH_NOT_FOUND_MEMBER: `${apiV1}/fetch/member/notFound/{email}`,
	FETCH_RITWICK_LIST: `${apiV1}/ritwick/list`,
	FETCH_GLOBAL_SEARCH_MEMBERS: `${apiV1}/search/members/global/withsearchkey/{name}/1/5000`,
	FETCH_KEYWORD_SEARCH_MEMBERS: `${apiV1}/search/members/global/withcriteria`,
	REFRESH_HEADER_USER_DATA_COUNT:`${apiV1}/fetch/effort-summary/refresh`,
	UPDATE_SERIAL_NO: `${apiV1}/update/searched/record`,
	FETCH_REPORT: `${apiV1}/admin/report`,
	FETCH_FOUND_MEMBER: `${apiV1}/members/found`,
	FETCH_DATE_WISE_EXPLORER_REPORT: `${apiV1}/fetch/user-summary`,
	FETCH_FOUND_MEMBER_BY_CRITERIA: `${apiV1}/member/byCriteria`,
	FETCH_FOUND_MEMBER_BY_MEMBER_ID: `${apiV1}/member/byId/{memberId}`,
	FETCH_DP_MEMBER_DETAILS_BY_MEMBER_ID: `${apiV1}/search/members/global/withsearchkey/{dpMemberId}/1/1`,
	ACCEPT_OR_REJECT_FOUND_MEMBER: `${apiV1}/manage/found/member`,
	USER_LIST: `${apiV1}/search/user/list`,
	FETCH_COMMAND_LIST: `${apiV1}/get/adv/queries`,
	EXECUTE_ADV_SEARCH_QUERY: `${apiV1}/execute/adv/query`,
	FETCH_TOTALLY_NOT_FOUND_MEMBER: `${apiV1}/fetch/member/totallyNotFound/{email}`,
	UPDATE_ADV_SEARCH_SERIAL_NO: `${apiV1}/update/advance/searched/record`,
	FETCH_FW_SUMMARY: `${apiV1}/fetch/fw-summary`,
	FETCH_TOTALLY_NOT_FOUND_DATA:`${apiV1}/fetch/exp-released-nf`,
	FETCH_SINGLE_TOTALLY_NOT_FOUND_MEMBER:`${apiV1}/fetch/dpnf-record`,
	GET_ALL_STATES:`${apiV1}/states`,
	GET_ALL_DISTRICTS:`${apiV1}/district`,
	ADD_NEW_RECORD:`${apiV1}/members/nf-records`,
	SET_PRIORITY:`${apiV1}/set/priority`,
	FETCH_NAME_SEARCH_MEMBERS:`${apiV1}/find/members`,
	FETCH_RESOURCE_STATUS:`${apiV1}/resource/status`
};
